/* Zivol Arc — before/after comparison.
 * Pointer events only, so mouse/touch/pen take one path. Under reduced motion
 * the CSS lays the two frames side by side and this returns before binding. */
(() => {
  const swap = document.querySelector('[data-arc-swap]');
  if (!swap) return;
  const range = swap.querySelector('[data-arc-range]');
  if (!range) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const set = (v) => swap.style.setProperty('--arc-pos', `${v}%`);
  range.addEventListener('input', () => set(range.value));

  let dragging = false;
  const fromEvent = (e) => {
    const r = swap.getBoundingClientRect();
    if (!r.width) return null;
    return Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
  };
  swap.addEventListener('pointerdown', (e) => {
    const p = fromEvent(e);
    if (p === null) return;
    dragging = true;
    swap.setPointerCapture?.(e.pointerId);
    range.value = String(Math.round(p));
    set(p);
  });
  swap.addEventListener('pointermove', (e) => {
    if (!dragging) return;
    const p = fromEvent(e);
    if (p === null) return;
    range.value = String(Math.round(p));
    set(p);
  });
  const stop = () => { dragging = false; };
  swap.addEventListener('pointerup', stop);
  swap.addEventListener('pointercancel', stop);
})();

/* Attach the deferred frames only when the section is approached. Without this
   they download inside the LCP window despite loading="lazy" — measured at
   2439ms against a 5304ms LCP. If IntersectionObserver is unavailable the URLs
   are attached immediately, which is the current behaviour rather than a
   regression. */
(() => {
  const imgs = [...document.querySelectorAll('img[data-arc-defer]')];
  if (!imgs.length) return;
  const attach = (img) => {
    const ss = img.getAttribute('data-srcset');
    const sr = img.getAttribute('data-src');
    if (ss) img.setAttribute('srcset', ss);
    if (sr) img.setAttribute('src', sr);
    img.removeAttribute('data-arc-defer');
  };
  if (!('IntersectionObserver' in window)) { imgs.forEach(attach); return; }
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) {
      if (e.isIntersecting) { attach(e.target); io.unobserve(e.target); }
    }
  }, { rootMargin: '300px 0px' });
  imgs.forEach((i) => io.observe(i));
})();
